import React from "react";
import { AwardItem } from "./AwardItem";

export const AwardList: React.FC = () => {
  return (
    <div className="p-4 max-w-6xl mx-auto mt-15">
      <h3 className="font-bold text-2xl uppercase mb-6 font-juana">Acumula HoloPoints con tus hábitos.</h3>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:flex md:flex-wrap md:gap-0">
        <AwardItem
          iconUrl="https://cache.beholos.com/img/fitness-pass-v2/corporate/dashboard/reward-icon-speech-bubble.svg"
          points="5 HoloPoints"
          description="Por escribir una review o comentario."
          link={{ href: "/user/mis-clases", label: "Escribir una reseña" }}
        />
        <AwardItem
          iconUrl="https://cache.beholos.com/img/fitness-pass-v2/corporate/dashboard/reward-icon-laptop.svg"
          points="0.33 HoloPoints/min."
          description={
            <>
              Con videos On-demand.<sup>1</sup>
            </>
          }
          link={{ href: "/user/clases-online", label: "Agendar un Video" }}
        />
        <AwardItem
          iconUrl="https://cache.beholos.com/img/fitness-pass-v2/corporate/dashboard/reward-icon-birthday-cake.svg"
          points="30 HoloPoints"
          description="Por tu cumpleaños."
        />
        <AwardItem
          iconUrl="https://cache.beholos.com/img/fitness-pass-v2/corporate/dashboard/logros-en-vivo.svg"
          points="30 HoloPoints"
          description={
            <>
              Por cada clase online o presencial asistida<sup>3</sup>
            </>
          }
          link={{ href: "/user/clases", label: "Agendar una clase" }}
        />
        <AwardItem
          iconUrl="https://cache.beholos.com/img/fitness-pass-v2/corporate/dashboard/logros-nutrition.svg"
          points="30 HoloPoints"
          description="Por cada sesión individual online con un nutricionista"
          link={{ href: "/user/nutricion", label: "Reservar una sesión" }}
        />
        <AwardItem
          iconUrl="https://cache.beholos.com/img/fitness-pass-v2/corporate/dashboard/logros-health-coach.svg"
          points="30 HoloPoints"
          description="Por cada sesión individual online con un Health Coach"
          link={{ href: "/user/health-coach", label: "Reservar una sesión" }}
        />
        <AwardItem
          iconUrl="https://cache.beholos.com/img/fitness-pass-v2/corporate/dashboard/logros-psych.svg"
          points="30 HoloPoints"
          description="Por cada sesión individual online con un Psicólogo"
          link={{ href: "/user/psicologia", label: "Reservar una sesión" }}
        />
        <AwardItem
          iconUrl="https://cache.beholos.com/img/fitness-pass-v2/corporate/dashboard/logros-psych.svg"
          points="30 HoloPoints"
          description="Por cada sesión individual online con un asesor Financiero"
          link={{ href: "/user/finanzas", label: "Reservar una sesión" }}
        />
        <AwardItem
          iconUrl="https://cache.beholos.com/img/fitness-pass-v2/corporate/dashboard/reward-icon-checklist.svg"
          points="50 HoloPoints"
          description="Por completar un programa especializado."
          link={{ href: "/user/programas", label: "Ver programas" }}
        />
      </div>

      <div className="text-left mt-6 text-xs">
        <span>
          Los HoloPoints son parte de nuestro sistema de recompensas. Tus hábitos saludables serán recompensados mediante dichos puntos. Acumula HoloPoints para alcanzar nuevos niveles y también para canjearlos en créditos, vales de consumo, entre otras opciones.
        </span>
        <br />
        <br />
                    <a href="/terminos" className="text-holos-dark font-medium">
          Ver términos y condiciones aquí.
        </a>
      </div>
    </div>
  );
};
